module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"yLabel":"Investitionskosten (CHF)","measureWINDOWS":"Fensterersatz","measureROOF":"Sanierung Dach","measureBASEMENT":"Sanierung Kellerdecke","measureWALLS":"Sanierung Fassade","measureHEATING":"Heizungsersatz","measurePV":"Installation Photovoltaik","measureElectricity":"Änderung Netzanschluss"}}')
  delete Component.options._Ctor
}
